import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgArrowIcon(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 46.29 32.92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M27.07 30.75a4.63 4.63 0 0 1-7.85 0L0 0h46.27Z",
    fill: "currentColor"
  }));
}

export { SvgArrowIcon as default };
